import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, ResolveFn } from "@angular/router";
import { TranslocoService } from "@jsverse/transloco";
import { map } from "rxjs";

type TitlePart =
    | { type: "translate"; key: string }
    | {
          type: "param";
          key: string;
          mapper?: (val: string, t: (key: string) => string) => string;
      };

export const titleResolver = (parts: TitlePart[], postFix = "appTitle"): ResolveFn<string> => {
    return (route: ActivatedRouteSnapshot) => {
        const transloco = inject(TranslocoService);

        return transloco.langChanges$.pipe(
            map(() => {
                const _parts = parts.map((part) => {
                    if (part.type === "translate") {
                        return transloco.translate(part.key);
                    }
                    if (part.type === "param") {
                        const value = route.paramMap.get(part.key);
                        return value ? (part.mapper ? part.mapper(value, (key: string) => transloco.translate(key)) : value) : "";
                    }
                    return "";
                });

                return _parts.filter((part) => part).join(" | ") + (postFix ? ` - ${transloco.translate(postFix)}` : "");
            })
        );
    };
};

export function translate(key: string): { type: "translate"; key: string } {
    return { type: "translate", key };
}

export function param(
    key: string,
    mapper?: (val: string, t: (key: string) => string) => string
): {
    type: "param";
    key: string;
    mapper?: (val: string, t: (key: string) => string) => string;
} {
    return { type: "param", key, mapper };
}
